import { useSuspenseQuery } from '@tanstack/react-query';

import { postRequest } from '@/api/rest/hooks/requests/post';
import {
  POST_ORGANIZATION_FINANCIAL_IMPACT_PATH,
  PostOrganizationFinancialImpactErrorDto,
  PostOrganizationFinancialImpactRequestBody,
  PostOrganizationFinancialImpactSuccessDto,
  ScenarioSettingsRequestBody,
} from '@/api/rest/resources/types/scenarioForecast';
import { useOrganizationId } from '@/pages/shared/hooks/useOrganizationId';

import { useEditScenario } from './useEditScenario';

type SuccessDto = PostOrganizationFinancialImpactSuccessDto;
type ErrorDto = PostOrganizationFinancialImpactErrorDto;

export const useOrganizationFinancialImpact = () => {
  const organizationId = useOrganizationId();
  const { values, isDemo } = useEditScenario();

  const pathVariables = { organization_id: organizationId };

  const bodyData: PostOrganizationFinancialImpactRequestBody = {
    scenario_settings: {
      biophysical_horizon: values.biophysical_horizon,
      climate_scenario: values.climate_scenario as ScenarioSettingsRequestBody['climate_scenario'],
      nrp_mode: values.nrp_mode as ScenarioSettingsRequestBody['nrp_mode'],
    },
    is_demo: isDemo,
  };

  const queryFn = () => {
    return postRequest<SuccessDto>(POST_ORGANIZATION_FINANCIAL_IMPACT_PATH, pathVariables, undefined, bodyData);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: ['scenario-forecast', 'financial-impact', pathVariables, bodyData],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
